/**
 * Checks if the Virtual Keyboard API is supported in the given navigator object.
 *
 * @param navigator the navigator object to check.
 * @returns A type guard indicating whether the Virtual Keyboard API is available.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/VirtualKeyboard_API
 */
export function supportsVirtualKeyboardApi(
  navigator: Navigator
): navigator is Navigator & { virtualKeyboard: VirtualKeyboard } {
  return (
    'virtualKeyboard' in navigator &&
    typeof navigator.virtualKeyboard === 'object'
  );
}
